<template>
	<div class="main-dest">
		<div id="divMenu">
			<Menus :menu="menu" icon="https://dsmlib.logistics.systems/Icons/icons8-country-100.png" @menuClicked="menuClicked" />
		</div>
		<div class="main-dest2">
			<div id="divMenu">
				<PopupEntry v-if="showPopup" :show.sync="showPopup" :title="entryTitle" @save="saveClicked" :createdBy="createdBy" :updatedBy="updatedBy"
					:errorMessages="eMessages" :successMessages="sMessages" :requiredError="rMessages" :viewMode="viewMode" :cancelButton="viewMode ? 'Close' : 'Cancel'">
					<!-- <div class="popup-details" id="popupDetails" > -->
						<Input placeholder="Zone Type" :inputValue.sync="selectedZoneType" :errorMessage.sync="zoneTypeError" :isDisabled="viewMode || entryTitle == 'Edit Zone'" :isRequired="true" />
						<div class="separator"></div>
						<Input placeholder="Zone Description" :inputValue.sync="selectedZoneTypeDescription" :errorMessage.sync="zoneTypeDescriptionError" :isDisabled="viewMode" :isRequired="true" />
						<Tab style="height: 100%;" :tabs="tabsItems" >
							<!-- Geofence tab -->
							<div slot="Geofence" style="height: 100%;  width: 100% ">
										<div class="mapSection" style="height: 90%; width: 100% ">
											<!-- <div class="mapSection"> -->
												<CustomMapV2 ref="customMapPopupEntry" :openMenu.sync="openMapMenu" :slotFloat="true" :markers.sync="destinationMarkers"  :existingMarkers.sync="fixedDestinationMarker"  :geofenceViewMode="geofenceViewMode" :ViewMode="viewMode"/>
										</div>
							</div>
							<!-- Zone Area tab -->
							<div slot="Zone Area" style="height: 100%; ">
								<!-- <div v-if="viewMode == false">
									<button @click="addAreaClicked" style="margin-left: 5px">+</button>
									<button @click="deleteAreaClicked" style="margin-left: 10px">-</button>
								</div> -->
								<TableBox title="Area List" :tableData="selectedArea" />
							</div>
							<!-- Zone Destination -->
							<div slot="Zone Destination" style="height: 100%; ">
								<TableBox title="Destination List" style="height: 95%; " :tableData="selectedDestination" />
							</div>
						</Tab>
					<!-- </div> -->
				</PopupEntry>

				<!-- <PopupEntry v-if="editShowPopup" :show.sync="editShowPopup" :createdBy="createdBy" :updatedBy="updatedBy" :errorMessages="eMessages"
					:successMessages="sMessages" :requiredError="rMessages" :title="editTitle" @save="editSaveClicked" :viewMode="edtViewMode" >
					<div class="popup-details" id="popupDetails" > -->
						<!-- Add Area table -->
						<!-- <div v-if="editAction == 'AA'" style="height: 100%">
							<TableBox title="Area List (with empty zone)" :tableData="emptyZoneAreaList" :maxSelection="-1" />
						</div> -->
						<!-- Delete Area table -->
						<!-- <div v-if="editAction == 'DA'" style="height: 100%">
							<TableBox title="Area List " :tableData="selectedArea" :maxSelection="-1" />
						</div>
					</div>
				</PopupEntry> -->
			</div>
			<!--Big Map-->
			<div id="destMap">
				<GoogleMap id="destMap" :marker_list="bigMarker" :polygon="bigPoly" @polyPathUpdate="updateBigPoly" :fitBounds="destGeofenceList"/>
			</div>
			<!-- Table -->
			<div class="destTable" :style="{ height: showMap ? '40%' : '100%' }">
				<div class="tabBox">
					<Tabulator class="tabtab" id="destTabulator" tableTitle="Zone List" tableID="destinationTable" :tableData="zoneList" :multiSelect="1"
						:selectedRow.sync="selectedZone" :currentPage.sync="zoneCurrentPage" />
				</div>
			</div>
		</div>
		<!--Loader-->
		<Loader :isVisible="loading" :loadingText="loadingText" />
	</div>
</template>

<script>  
/* eslint-disable */
import Tabulator from "@/components/Tabulator.vue";
import GoogleMap from "@/components/GoogleMap.vue";
import Loader from "@/components/Loader.vue";
import Tab from "@/components/Tab.vue";
import Menus from "@/components/Menus.vue";
import PopupEntry from "@/components/PopupEntry.vue";
import GmapLocation from "@/components/GmapLocation.vue";
import CustomMapV2 from "@/components/CustomMapV2.vue";


export default {
	components: {
		Tabulator,
		GoogleMap,
		CustomMapV2,
		Loader,
		Tab,
		Menus,
		PopupEntry,
		GmapLocation,
	},
	data: function () {
		return {
			//Loading Screen
			loading: false, //Loading Screen
			loadingText: "", //Loading Screen Text
			pageType: "",
			tableLoading: false,
			destAction: "",
			eMessages: [],
			sMessages: [],
			rMessages: [],

			menu: [
				{
					title: "New Zone",
					icon: "https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png",
				},
				{
					title: "Edit Zone",
					icon: "https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64%20(1).png",
				},
				{
					title: "Delete Zone",
					icon: "https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png",
				},
				{
					title: "View Zone",
					icon: "https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png",
				},
				{
					title: "Show Map",
					icon: "https://dsmapi.logistics.systems/dsm6gicons/Map.png",
				},
			],

			currentTabIndex: 0,
			tabsItems: [
				{ title: "Geofence" },
				{ title: "Zone Area" },
				{ title: "Zone Destination" },
			],

			//Big Map
			//Coordinate List to place markers
			destCoordList: [], //Markers on current table (for big map)
			tableCoordList: [],
			bigMarker: [],

			//Fit all markers in map
			destFitBounds: {},
			destGeofenceIndividual: [],
			destGeofenceList: [], //Geofence on current table (for big map)
			tableGeofenceList: [],

			//Table
			zoneList: [],
			showMap: false,
			geofenceClicked: true,
			zoneCurrentPage: 1,
			zoneCurrentRowSize: 0,
			selectedZone: [], //Selected row on table
			selectedArea: [],
			selectedDestination: [],

			//Entry Popup
			destinationList: [],
			areaList: [],
			emptyAreaList: [],
			zoneDetailsList: [],
			allZoneDetailsList: [],
			postcodeList: [],
			showPopup: false, //Popup on/off
			entryTitle: "", //Popup Form Title
			updatedBy: "",
			createdBy: "",
			lastUpdate: "",
			viewMode: false,
			entryMessages: [],
			zoneTypeError: "",
			zoneTypeDescriptionError: "",
			geofenceTitle: "",

			//tab items
			selectedZoneTypeDescription: "",
			selectedZoneType: "",
			selectedGeofence: [],

			tempSelectedArea: [],
			selectedArea: [],
			finalSelectedArea: [],

			selectedDestination: [],

			//Edit popup
			editAction: "",
			editShowPopup: false,
			editViewMode: true,
			editTitle: "",
			editYesNo: 0,

			emptyZoneAreaList: [],
			editAddedArea: [],
			editDeletedArea: [],

			// For Big google Map
			bigPoly: [],
			bigMapBounds: [],

			// For Popup google map
			myPoly: [],
			openMapMenu : false,
			destinationMarkers: [],
			fixedDestinationMarker: [],
			geofenceViewMode: false,
			mapBounds: [],
			markerCount: -1,
			centerPoint: {},

		};
	},
	props: {},
	methods: {
		menuClicked: function (e) {
			switch (e.title) {
				case "New Zone":
					this.newClicked();
					break;
				case "Edit Zone":
					
					this.editClicked();
					break;
				case "Delete Zone":
					this.deleteClicked();
					break;
				case "View Zone":
					this.viewClicked();
					break;
				case "Show Map":
					this.$set(this.menu[4], "title", "Hide Map");
					this.$set(
						this.menu[4],
						"icon",
						"https://dsmapi.logistics.systems/dsm6gicons/MapHide.png"
					);
					this.showMap = true;
					break;
				case "Hide Map":
					this.$set(this.menu[4], "title", "Show Map");
					this.$set(
						this.menu[4],
						"icon",
						"https://dsmapi.logistics.systems/dsm6gicons/Map.png"
					);
					this.showMap = false;
					break;
			}
		},
		checkFields: function () {
			let error = false;

			if (!this.selectedZoneType.trim()) {
				error = true;
				this.zoneTypeError = "Zone Type is required!";
			}
			else if (this.selectedZoneType.length > 5) {
				error = true;
				this.zoneTypeError = "Zone Type cannot exceed 5 characters!"
			}
			if (!this.selectedZoneTypeDescription.trim()) {
				error = true;
				this.zoneTypeDescriptionError = "Zone description is required!";
			}
			else if (this.selectedZoneTypeDescription.length > 100) {
				error = true;
				this.zoneTypeDescriptionError = "Zone description cannot exceed 100 characters!";
			}
			if (this.destinationMarkers.length == 0) {
				error = true;
				this.$showAlert('error', "No Geofence is Selected", ``);
			}

			return error;
		},
		newClicked: async function () {
			this.destinationMarkers =[];
			this.fixedDestinationMarker = [];
			this.clearForm();
			this.destAction = "N";
			await this.retrieveAllZoneDetails();
			this.$nextTick(() => {
				this.entryTitle = "New Zone";
				this.showPopup = true;
				this.geofenceViewMode = true;
				this.viewMode = false;
			});
		},
		deleteClicked: async function () {
			this.clearForm();
			this.destAction = "D";
			if (!this.selectedZone[0]) {
				this.$showAlert(
					'error',
					"No Zone Selected",
					`Please select a record to delete`
				);
			} else {
				var isDelete = await this.$showAlert(
					'warning',
					"Delete Zone",
					`Are you sure you want to delete this Zone?`,
					[
						{text: 'Delete'},
						{text: 'Cancel'}
					]
				);
				if (isDelete === 'Delete') {
					var dataToPost = {
						action: "D",
						zonetype: this.selectedZone[0]["Zone Type"],
					};
					var destUpdate = dataToPost;
					var postUpdate = await this.$apiCallV2("/Zone/SaveZone", destUpdate);

					if (postUpdate[0].Results == 0) {
						this.$showAlert('success', "Delete", "Zone Deleted");
					} else {
						this.$showAlert(
							'error',
							"Zone not Deleted",
							postUpdate[0].ErrMsg
						);
					}
				}
			}
			this.getZone();
		},
		viewClicked: async function () {
			this.destinationMarkers =[];
			this.fixedDestinationMarker = [];
			await this.retrieveAllZoneDetails();
			this.$nextTick(() =>{
				this.clearForm();
				this.destAction = "V";
				if (!this.selectedZone[0]) {
					this.$showAlert(
						'error',
						"No Zone Selected",
						`Please select a record to view`
					);
				} else {
					this.retrieveSelectedZoneDetails();
					this.entryTitle = "View Zone";
					this.geofenceViewMode = true;
					this.viewMode = true;
					this.showPopup = true;
				}
			});
		},
		editClicked: async function () {
			this.destinationMarkers =[];
			this.fixedDestinationMarker = [];
			this.clearForm();
			await this.retrieveAllZoneDetails();
			this.$nextTick(() => {
				this.destAction = "E";
				if (!this.selectedZone[0]) {
					this.$showAlert(
						'error',
						"No Zone Selected",
						`Please select a record to edit`,
					);
				} else {
					this.retrieveSelectedZoneDetails();
					this.geofenceViewMode = true;
					this.entryTitle = "Edit Zone";
					this.viewMode = false;
					this.showPopup = true;
				}
			});
		},
		saveClicked: async function () {
			this.eMessages = [];
			this.sMessages = [];
			this.rMessages = [];
			if (this.checkFields()) {
				return;
			}
			console.log(this.destinationMarkers[0].geofence);
			if(this.destinationMarkers[0].geofence == null)
			{
				this.$showAlert('error', 'No Geofence Added','Please add geofence to save');
				return;
			}
			this.loading = true;
				console.log(this.destinationMarkers);

			if (this.destAction == "N") {
				this.loadingText = "Saving New Zone";
			}
			if (this.destAction == "E") {
				this.loadingText == "Updating Zone";
			}

			if (
				this.selectedArea.length == 0 &&
				this.selectedDestination.length == 0 &&
				this.selectedZoneType &&
				this.editYesNo == 0
			) {
				var action = "N";
			} else {
				var action = "E";
			}

			let tempAllZoneArea = this.tempSelectedArea.map((t) => t["Area Code"]);
			let allZoneArea = this.selectedArea.map((t) => t["Area Code"]);

			var addedArea = allZoneArea.filter((x) => !tempAllZoneArea.includes(x));
			var deletedArea = tempAllZoneArea.filter((x) => !allZoneArea.includes(x));

			addedArea = addedArea.map((a) => {
				return { areaaction: "N", areacode: a ? a.trim() : "" };
			});
			deletedArea = deletedArea.map((d) => {
				return { areaaction: "D", areacode: d ? d.trim() : "" };
			});

			this.finalSelectedArea = [...addedArea, ...deletedArea];

			this.loading = false;

			//Destination list wont refresh issue unless a random data is added or deleted from the list,
			//therefore adding a dummy data would solve the issue
			var tempdest = [{ destaction: "N", destcode: "" }];
			console.log('this.destinationMarkers');
			console.log(this.destinationMarkers[0]);
			var dataToPost = {
				action: action,
				zonetype: this.selectedZoneType,
				description: this.selectedZoneTypeDescription,
				area: this.finalSelectedArea,
				destination: tempdest,
				geofence: this.destinationMarkers[0].geofence.map((g, i) => {
					return {
						VertexID: `${i + 1}`,
						gfLat: (Math.round(g.lat * 10000000) / 10000000).toString(),
						gfLon: (Math.round(g.lng * 10000000) / 10000000).toString(),
					};
				}),
			
			};
			console.log(dataToPost);
			var destUpdate = dataToPost;
			var postUpdate = await this.$apiCallV2("/Zone/SaveZone", destUpdate);

			//Check for errors
			if (postUpdate[0].Results >= 1) {
				console.log(postUpdate[0].ErrMsg);
				this.eMessages.push(postUpdate[0].ErrMsg);
			} else {
				this.getZone();
				this.sMessages.push("Successfully updated Zone!");
				this.viewMode = true;
				this.destinationMarkers = [];
				this.fixedDestinationMarker = [];

			}
			console.log(
				"after saving zone details, retrieve updated zone details, especially zone destination"
			);
			// this.retrieveSelectedZoneDetails();
			this.retrieveAllZoneDetails();

			this.loading = false;
		},
		addAreaClicked: async function () {
			this.editShowPopup = true;
			this.editAction = "AA";
			this.editTitle = "Add Area";
		},
		deleteAreaClicked: async function () {
			this.editShowPopup = true;
			this.editAction = "DA";
			this.editTitle = "Delete Area";
		},
		editSaveClicked: async function () {
			//Add area
			console.log("editsaveclicked");
			if (this.editAction == "AA") {
				let temp = this.selectedArea;
				this.selectedArea = [];
				temp = temp.concat(this.editAddedArea); // add

				this.$nextTick(() => {
					this.selectedArea = temp;
				});

				this.editAddedArea.forEach((e) => {
					let index = this.emptyZoneAreaList.indexOf(e);
					this.emptyZoneAreaList.splice(index, 1); //delete
				});

				this.editAddedArea = [];

				this.editShowPopup = false;
			}
			//Delete Area
			if (this.editAction == "DA") {
				let temp = this.selectedArea;
				this.selectedArea = [];

				this.editDeletedArea.forEach((e) => {
					let index = temp.indexOf(e);
					temp.splice(index, 1);
				});

				this.$nextTick(() => {
					this.selectedArea = temp;
				});

				this.emptyZoneAreaList = this.emptyZoneAreaList.concat(
					this.editDeletedArea
				);

				this.editDeletedArea = [];

				this.editShowPopup = false;
			}

		},
		getZone: async function () {
			this.loading = true;
			this.loadingText = "Getting Zones";
			var zonesList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'zone' });
			this.zoneList = zonesList;
			this.loading = false;
		},
		getArea: async function () {
			this.emptyZoneAreaList = [];
			this.loading = true;
			this.loadingText = "Getting Areas";
			var areas = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'area' });
			this.areaList = areas;
			this.emptyZoneAreaList = this.areaList.filter((z) => z["Zone"] == "");
			this.loading = false;
		},
		getDestination: async function () {
			this.loading = true;
			this.loadingText = "Getting Destination";
			var destAPI = await this.$apiCallV2('/Master/GetListMaster', { masterfile : 'destination' });
			this.destinationList = destAPI;
			this.loading = false;
		},
		retrieveAllZoneDetails: async function(){
			this.allZoneDetailsList =[];
			let zoneDetailsAPI = await this.$apiCallV2('/Master/GetListMaster', {masterfile: 'zone' });
			let format = zoneDetailsAPI.map(d => {
				let geofenceList = JSON.parse(`[${d['Geofence']}]`);
				return geofenceList.length == 0 ? null : {
					zone: d['Zone Type'],
					position: {
						lat: geofenceList[0][0],
						lng: geofenceList[0][1],
					},
					geofence: geofenceList.map(g => {
						return {
							lat: g[0],
							lng: g[1]
						}
					})
				};
			});
			let temp = [];
			temp = format.filter(f => f);
			if(this.selectedZone.length > 0 && this.destAction != "N"){
				var selectedZone = this.selectedZone[0]["Zone Type"].trim();
				var selectedZoneDetailsAPI = await this.$apiCallV2(`/Zone/GetDetailsMaster?masterFile=zonetype&module=MASTER&recordid=${selectedZone}`);
				this.zoneDetailsList = selectedZoneDetailsAPI["ZoneType"];

				if (this.zoneDetailsList.Geofence && this.zoneDetailsList.Geofence.length > 0) 
				{
					var retrievedGeofenceList = [];
					this.zoneDetailsList.Geofence.forEach((g) => {
						var indGeofence = {
							lat: parseFloat(g.gfLat),
							lng: parseFloat(g.gfLon),
						};
						retrievedGeofenceList.push(indGeofence);
					});
					
					this.destinationMarkers.push({
						position: {
							lat: retrievedGeofenceList[0].lat,
							lng: retrievedGeofenceList[0].lng
						},
						geofence: retrievedGeofenceList
					});
					this.fixedDestinationMarker = temp.filter(selected => selected.zone != this.zoneDetailsList.ZoneType); 
				}

			}
			else
			this.fixedDestinationMarker = temp;

		},
		retrieveSelectedZoneDetails: async function () {
			this.loadingText = "Retrieving Zone Details";
			this.loading = true;
			if (this.destAction == "E" || this.destAction == "V") {
				var selectedZone = this.selectedZone[0]["Zone Type"].trim();
				var zoneDetailsAPI = await this.$apiCallV2(`/Zone/GetDetailsMaster?masterFile=zonetype&module=MASTER&recordid=${selectedZone}`);
				this.zoneDetailsList = zoneDetailsAPI["ZoneType"];
			
				this.loading = false;
			}

			if (this.destAction == "N") {
				var zoneDetailsAPI = await this.$apiCallV2(`/Zone/GetDetailsMaster?masterFile=zonetype&module=MASTER&recordid=${this.selectedZoneType.trim()}`);
				this.zoneDetailsList = zoneDetailsAPI["ZoneType"];
				
				this.loading = false;
			}

			this.selectedZoneType = this.zoneDetailsList.ZoneType;
			this.selectedZoneTypeDescription = this.zoneDetailsList.ZoneTypeDesc;

			// this.selectedArea = this.zoneDetailsList.Area;
			if (this.zoneDetailsList.Area && this.zoneDetailsList.Area.length > 0) {
				this.selectedArea = this.zoneDetailsList.Area.map((d) => {
					return this.areaList.find(
						(a) => a["Area Code"].trim() == d["Area Code"].trim()
					);
				});
			}
			//if there is only one area, array will become object, therefore if area is object,
			// then it will pass the only one area code to filter or find the selected area
			else if (
				this.zoneDetailsList.Area &&
				Array.isArray(this.zoneDetailsList.Area) == false
			) {
				var selectedareacode = this.zoneDetailsList.Area["Area Code"].trim();
				this.selectedArea = this.areaList.filter(
					(a) => a["Area Code"].trim() == selectedareacode
				);
			} else {
				this.selectedArea = [];
			}
			this.tempSelectedArea = JSON.parse(JSON.stringify(this.selectedArea));

			if (
				this.zoneDetailsList.Destination &&
				this.zoneDetailsList.Destination.length > 0
			) {
				this.selectedDestination = [];
				var temp = this.zoneDetailsList.Destination.map((d) => {
					return this.destinationList.find(
						(a) => a["Destination Code"].trim() == d["Destination Code"].trim()
					);
				});
				this.$nextTick(() => {
					this.selectedDestination = temp;
				});
			} else {
				this.selectedDestination = [];
			}
			if (
				this.zoneDetailsList.Geofence &&
				this.zoneDetailsList.Geofence.length > 0
			) {
				var retrievedGeofenceList = [];
				this.zoneDetailsList.Geofence.forEach((g) => {
					var indGeofence = {
						lat: parseFloat(g.gfLat),
						lng: parseFloat(g.gfLon),
					};
					retrievedGeofenceList.push(indGeofence);
				});
				if (this.destAction == "V") {
					this.viewMode = true;
					
					this.destinationMarkers.push({
						position: {
						lat: retrievedGeofenceList[0].lat,
						lng: retrievedGeofenceList[0].lng
					},
					geofence: retrievedGeofenceList
				});
				} else {
					this.viewMode = false;
					this.destinationMarkers.push({
					zone: this.zoneDetailsList.ZoneType,
					position: {
						lat: retrievedGeofenceList[0].lat,
						lng: retrievedGeofenceList[0].lng
					},
					geofence: retrievedGeofenceList
				});
				await this.retrieveAllZoneDetails();
				}
			}

			this.loading = false;
			this.editYesNo = 1;
		},
		clearForm: function () {
			this.currentTabIndex = 0;
			this.geofenceClicked = false;
			this.destAction = "";
			this.sMessages = [];
			this.eMessages = [];
			this.editYesNo = 0;
			this.selectedArea = [];
			this.tempSelectedArea = [];
			this.finalSelectedArea = [];

			this.selectedDestination = [];

			(this.editAddedArea = []),
				(this.editDeletedArea = []),
				(this.selectedZoneType = "");
			this.selectedZoneTypeDescription = "";
			this.entryTitle = "";
			this.myPoly = [];
			this.zoneTypeError = "";
			this.zoneTypeDescriptionError = "";
		},
		closePopup: function () {
			this.editShowPopup = false;
		},
		
		//#region Google Map 
		setPoly: async function () {
			let map = this.$refs["gmap"].getMapObject();
			// let midcoordinate = { lat: 3.1579704747856923, lng: 101.71176723346404 };
			let midcoordinate = {
				lat: map["center"].lat(),
				lng: map["center"].lng(),
			};

			this.centerPoint = midcoordinate;
			let polyWidth = map["zoom"] / 100;
		
			this.myPoly = [
				{
					Path: [
						{
							lat: midcoordinate.lat + polyWidth,
							lng: midcoordinate.lng + polyWidth,
						},
						{
							lat: midcoordinate.lat + polyWidth,
							lng: midcoordinate.lng - polyWidth,
						},
						{
							lat: midcoordinate.lat - polyWidth,
							lng: midcoordinate.lng - polyWidth,
						},
						{
							lat: midcoordinate.lat - polyWidth,
							lng: midcoordinate.lng + polyWidth,
						},
					],
					Edit: true,
				},
			];

			this.fitMapToGeofence();
		},
		resetPoly: async function () {
			let reset = false;
			if (this.myPoly.length > 0) {
				if (this.myPoly[0]["Path"]) {
					reset = await this.$showAlert(
						'warning',
						"Reset geofence",
						"Are you sure you want to reset your geofence?",
						[{text: "Yes"}, {text: "No"}]
					);
					if (reset === 'No') {
						return;
					}
				}
			}
			let map = this.$refs["gmap"].getMapObject();
			// let midcoordinate = { lat: 3.1579704747856923, lng: 101.71176723346404 };
			let midcoordinate = {
				lat: map["center"].lat(),
				lng: map["center"].lng(),
			};
			let polyWidth = map["zoom"] / 100;

			this.myPoly = [
				{
					
					Path: [
						{
							lat: midcoordinate.lat + polyWidth,
							lng: midcoordinate.lng + polyWidth,
						},
						{
							lat: midcoordinate.lat + polyWidth,
							lng: midcoordinate.lng - polyWidth,
						},
						{
							lat: midcoordinate.lat - polyWidth,
							lng: midcoordinate.lng - polyWidth,
						},
						{
							lat: midcoordinate.lat - polyWidth,
							lng: midcoordinate.lng + polyWidth,
						},
					],
					Edit: true,
				},
			];
			this.fitMapToGeofence();
		},
		//testing purpose
		// getPolygon: function() {
		// 	var geofenceToPost = [];
		// 	if (this.myPoly.length > 0) {
		// 		this.myPoly[0].Path.forEach((geo,i) => {
		// 			geofenceToPost.push({	VertexID: i.toString(),	gfLat: geo.lat.toString(), gfLon: geo.lng.toString(),	})
		// 		})
		// 	}
		// },
		updatePoly: function (e) {
			if (this.myPoly.length > 0) {
				this.myPoly[0]["Path"] = e;
			}
		},
		updateBigPoly: function (e) {
			if (this.bigPoly.length > 0) {
				this.bigPoly[0]["Path"] = e;
			}
		},
		fitMapToGeofence: function () {
			if (this.myPoly.length > 0) {
				if (this.myPoly[0]["Path"]) {
					this.mapBounds = this.myPoly[0]["Path"];
				}
			}
		},
		fitBigMapToGeofence: function () {
			if (this.bigPoly.length > 0) {
				if (this.bigPoly[0]["Path"]) {
					this.bigMapBounds = this.bigPoly[0]["Path"];
				}
			}
		},
	//#endregion
	
	},
	watch: {
		selectedZone: async function () {
			if (this.selectedZone.length == 0) {
				this.bigPoly = [];
				this.bigMarker = [];
			} else if (this.selectedZone.length > 0) {
				this.loadingText = "Retrieving Zone Geofence";
				this.loading = true;

				var sZone = this.selectedZone[0]["Zone Type"].trim();
				var zoneDetailsAPI = await this.$apiCallV2(`/Zone/GetDetailsMaster?masterFile=zonetype&module=MASTER&recordid=${sZone}`);
				var zoneDetails = zoneDetailsAPI["ZoneType"];
				var zoneGeofence = zoneDetails.Geofence;

				this.destGeofenceList = [];
				if(zoneDetails?.Geofence)
				{
					for(var i = 0 ; i < zoneDetails["Geofence"].length ; i++)
					{
						this.destGeofenceList.push({lat:zoneDetails["Geofence"][i]["gfLat"], lng:zoneDetails["Geofence"][i]["gfLon"]})
					}
				}
				
				if (zoneDetails.Destination && zoneDetails.Destination.length > 0) {
					var zoneDestination = zoneDetails.Destination.filter(
						(z) => z["Latitude"] > 0 && z["Longitude"] > 0
					);

					if (zoneDestination.length > 0) {
						var marker = zoneDestination.map((g) => {
							return {
								position: {
									lat: parseFloat(g["Latitude"]),
									lng: parseFloat(g["Longitude"]),
								},
								draggable: false,
								clickable: true,
								info: [
									{
										type: "string",
										title: g["Company"].trim(),
										string: g["Address"].trim(),
									},
								],
							};
						});
						if (marker.length > 0) {
							this.bigMarker = [];
							this.bigMarker.push(marker);
						}
					} else {
						this.bigMarker = [];
					}
				} else {
					this.bigMarker = [];
				}
				this.loading = false;

				if (!zoneGeofence) {
					this.bigPoly = [];
				}
				if (zoneGeofence && zoneGeofence.length > 0) {
					var bigMapGeofence = [];
					zoneGeofence.forEach((g) => {
						var indGeofence = {
							lat: parseFloat(g.gfLat),
							lng: parseFloat(g.gfLon),
						};
						bigMapGeofence.push(indGeofence);
					});
					this.bigPoly = [{ Path: bigMapGeofence, Edit: false }];
					this.fitBigMapToGeofence();
				}
			}
		},
		showPopup: async function () {
			if (this.$route.query['new'] && !this.viewMode) { // When the cancel is click but is not saved (for query new=1)
        let closeWindow = await this.$showAlert('warning', 'Cancelling Zone Creation', `You have not created an Zone profile.\nAre you sure you want to cancel?\n\nIf you cancel, this page will close.`, [
          { "text": "Continue Creating" },
          { "text": "Cancel Creating", "color": "red", "textColor": "white" }
        ]);

        if (closeWindow == 'Cancel Creating') { // If user choose to cancel the creating process, it will close the tab
          window.close();
        } else {
          this.showPopup = true;
        }
      } else if (this.$route.query['new'] && this.viewMode) {
        window.close();
      }

			if (this.showPopup == false) {
				this.getZone();
			}
		},
	},
	mounted: async function () {
		//Destination
		await this.getDestination();
		//Areas
		await this.getArea();
		//Zones
		await this.getZone();

		if (this.$route.query['new']) {
      this.menuClicked({ title: 'New Zone' });
    }
	},
};
</script>

<style lang="scss" scoped>
.main-dest {
	width: 100%;
	height: 100%;
	padding: 3px 45px;
	overflow: hidden;
	display: flex;
}

#divMenu {
	font-size: 12px;
}

.main-dest2 {
	display: flex;
	flex-direction: column;
	width: auto;
	height: auto;
	flex: 1;
	padding-left: 5px;
	width: 100%;
	height: 100%;
}

.tab-block {
	display: flex;
	width: 100%;
	border: 1px solid rgba(0, 0, 0, 0.5);
	margin-top: 10px;
	margin-bottom: 10px;
	position: relative;
	padding-top: 10px;
	padding-left: 5px;

	> .tab-title {
		width: fit-content;
		background-color: white;
		position: absolute;
		top: -10px;
		left: 10px;
		padding: 0 10px;
	}

	> .details-column {
		width: calc(100% / 3);
		margin-right: 5px;
	}
}

.tabBox {
	width: 100%;
	height: 100%;
	position: relative;
}

.tabtab {
	width: 100%;
	height: auto;
	position: absolute;
	top: 0px;
	bottom: 38px;
}

#destMap {
	width: 100%;
	flex: 1;
}

.destTable {
	padding-bottom: 2.5%;
}

.popupentry-tab {
	height: 100%;
	width: 100%;
}

.popup-details {
	background-color: blue;
}


.zone-tab {
	height: 100%;
	background-color: yellow;
}

.separator {
	height: 3px;
	width: 100%;
	margin: 5px;
}

.mapDiv {
	height: 400px;
	padding-top: 10px;
	padding-bottom: 10px;
}

.sideMapDiv {
	display: flex;
	justify-content: space-between;
}

.customFont {
	font-size: 12px;
}

.inputSection {
	padding-right: 5px;
}

.mapSection {
	padding: 5px;
	align-content: center;
}

.mapSection, .inputSection {
	height: 100%;
	width: 50%;
}
</style>